import React, { Component } from 'react';
import {
  Row, Col,
  Container,
} from 'reactstrap';
import MyProfile from '../../components/Profile/MyProfile';
import DashboardTilesContainer from '../../components/DashboardTiles/DashboardTilesContainer';
import PermissionWrapper from '../../auth/PermissionWrapper';

class Profile extends Component {

  render() {
    return (
      <Container fluid={true} className='p-0'>
        <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
          <Row>
            <Col md={12} className='text-center'>
              <h1>My Profile</h1>
            </Col>
          </Row>
        </PermissionWrapper>
        <MyProfile {...this.props} />
        <DashboardTilesContainer {...this.props} />
      </Container>
    );
  }
}

export default Profile;
